export default "__VITE_ASSET__BQO9IxX$__"